import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';

import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type { EditorPluginAIConfigItem } from '../../config-items';

export const freeGenerateAifc: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.FREE_GENERATE_AIFC,
	// This is to avoid StateMachine `guard` check
	title: {
		id: 'free-generate-aifc-title',
		defaultMessage: 'Free Generate AIFC',
	},
	description: sharedMessages.aiUniversalLongCallToAction,
	promptHint: aiConfigItemMessages.freeGeneratePromptHint,
	adfPrompt: true,
	doNotHighlightDocWhenSelectionIsEmpty: true,
	intentSchemaId: 'custom_free_generate_intent_schema.json',
	actions: {},
	getBackendModel: () => 'aifc-bridge',
};
